// Module
var code = `<mat-dialog-content>
    <div class="hoa-dialog__container">
        <div class="hoa-dialog__header">
            <h1 tid="registerPropertyConfirmationHeader">
                Property Confirmation Successful
            </h1>
        </div>
        <div class="hoa-dialog__main">
            <p tid="registerPropertyConfirmationBody" align="center">
                Select continue to complete your registration.
            </p>
            <p align="center">
                        <span class="Icon Icon--72 u-strokeGreenDarker">
                            <svg xmlns="http://www.w3.org/2000/svg"
                                 width="72"
                                 height="72"
                                 viewBox="0 0 72 72">
                                <title>Select continue to complete your registration.</title>
                                <path d="M63.3 36a27 27 0 1 1-27-27 27 27 0 0 1 27 27z"
                                      fill="none"
                                      stroke="#838383"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      stroke-width="2">
                                </path>
                                <path d="M23.9 39l9.1 9.3 15.6-24.6"
                                      fill="none"
                                      stroke="#838383"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      stroke-width="2">
                                </path>
                            </svg>
                        </span>
            </p>
        </div>
        <div class="hoa-dialog__footer" ifOverFlowXClass="hoa-dialog__footer--overflowX">
            <button class="Button Button--blue Button--minWidth130"
                    (click)="closeDialog('continue')"
                    align="center"
                    tid="registerPropertyConfirmationContinueButton">
                Continue
            </button>
        </div>
    </div>
</mat-dialog-content>`;
// Exports
module.exports = code;